module.exports = __webpack_public_path__ + "static/img/IMG_3323.c369f97.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/news/gallery/11/IMG_3323.jpg
// module id = 681
// module chunks = 0